/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import timezones from "../../../timezones.json";
import Select from "react-select";

import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer,
  CustomCheckBoxButton,
} from "../CreateEvent/style";

import { closeIcon, RecognitionCloseIcon, UploadHDMIcon, RecognitionTickIcon, SearchButtonIcon, NewDropDownIcon, CalendarBranding } from "../../utils/icons";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { CommonButtonBorder } from "../common/commonStyles";
import { Border } from "../Journeys/styles";
import { FormHeading, DateCard } from "../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { DateCalendarWrapper } from "../ChallengeDetailsV2/StartChallengePopUp/styles";
import DatePopupCalendar from "../common/DateRangePicker/daCalendarPopup";
import { ManagerIconContainer } from "../Manager/styles";
import CommonImageUploaderFile from "../common/CommonImageUploader/CommonImageUploaderFile";
import Editor from "../CKEditor";
import { Main, TitleContainer } from "../AdminTeamCreation/styles";
import StepsHeading from "../../components/RecogntionAdmin/corevalues/stepNames";
import CommonDropdown from "../common/CommonDropDown/CommonDropdown";
import { GetWellbeingPillars, GetTeams, GetRecurringInitiativesMonthsNames, GetWellnessChallengeDetailsById, LaunchWellnessChallenge } from "../../redux/constants/apiConstants";
import { wellnessChallengePoints, recurringTypes } from "../../../mockData";
import { ImageUrl } from "../../utils/constants";
import { fetchApi, getPermissionStatus } from "../../utils/methods";
import { http } from "../../redux/http";
import Waiting from "../Waiting";
import CustomRadioButton from "../CustomRadioButton";
import { SearchFilter1, SearchIcon } from "../PeopleHomeV2/styles";
import {
  Locationwrapper,
  SearchDropDown,
  CustomRadioButton as StyledCustomRadioButton,
} from "../ReportsV2/LaunchCompanyInitiative/style";
import { Heading } from "../RecogntionAdmin/corevalues/styles";
import { getCompanyLocation, getCompanyDepartment, getAllCompanies } from "../../redux/actions";
import { allowChallengeEventForSpouseDependent, getUserCompanyDetails } from "../../redux/actions/userProfileActions";
import { getCompanyInitiatives } from "../../redux/actions/companyDashboard";
import {
  SummaryRow,
  SummaryColumn,
  SummaryCard,
  SummaryHeading,
  SummaryValue,
  SummaryBulletList,
  SummaryBulletItem,
} from "./styles";


class LaunchLegacyChallengeForm extends Component {
  constructor(props) {
    super(props);
    this.csvInputRef = React.createRef();
    this.state = {
      // Step 1 - challenge details
      title: "",
      videoTitle: "",
      videoUrl: "",
      challenge_level: null,
      pointValue: "",
      url: "",
      pillar_Id: this.props.history.location?.state?.category_Id,
      categoryDescription: this.props.history.location?.state?.categoryDescription,
      options: ["", ""],
      description: "",
      selectedLinkOption: 0,
      selectedJournalingOption: 0,
      imageName: "",
      selectedWellbeingPillar: null,
      challengePointValue: null,
      challengePointKey: null,
      audio: "",
      imgSrc: "",
      imageFile: null,
      library_id: null,
      classTypeKey: "",
      selectedValues: [],
      buttonstatus: false,
      step: 1,
      selectedChallengePoint: "",
      file: null,
      fileName: "",
      csvUpload: false,
      points: null,
      so: false,
      audioName: "",
      isVideoUrl: false,
      buttonClickScrollTop: false,
      so2: false,
      question: "",
      levels: null,
      loading: false,
      so3: false,
      audio_link: "",
      iseventUrlMsg: "",
      wellbeingPillars: [],
      charCount: 0,
      selectedOption: 0,
      selectedAudioVideoOption: 0,
      themeId: null,
      active: false,
      expandedWeek: 0,
      expandedDay: null,
      weeksData: [],
      activeModalDay: null,

      // Step 3 - audience targeting
      companies: [],
      city_location: [],
      departments: [],
      teams: [],
      isSpouse: false,
      isDependent: false,
      isEmployee: false,
      usersToInvite: 0,
      allTeams: [],
      filteredCompanies: [],
      searchTerm: "",
      companiesPermission: false,
      locationPermission: false,
      selectedCompanyCheckBox: 0,
      selectedCompanyValue: "",

      // Challenge details from API
      challengeDetails: null,
      challengeLength: null,

      // Step 4 - launch timing
      date: dayjs(),
      endDate: null,
      time_zone: null,
      defaultTz: "",
      launch: 0,
      recurringType: "one_time",
      selectedMonths: [],
      currentYear: new Date().getFullYear(),
      showDatePopupModal: false,
      datePopup: "",
      availableMonths: [],
      menuIsOpen: false,
      recurringEvent: recurringTypes[0],

      // Step 5 - notifications
      emailOption: {
        launch_event_email: 0,
        event_reminder_email: 0,
        event_complete_email: 0,
      },
      buttonStatus: false,
      value: null,
      isUploadDoc: false,
    };
  }

  componentDidMount() {
    const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.setState({
      time_zone: timezoneName === "Asia/Calcutta" ? "Asia/Kolkata" : timezoneName,
      defaultTz: timezoneName === "Asia/Calcutta" ? "Asia/Kolkata" : timezoneName,
    });

    this.getAllWellbeingPillars();

    if (this.props.history.location?.state?.category_Id) {
      this.setState({ pillar_Id: this.props.history.location?.state?.category_Id });
    }

    const companiesPermission = getPermissionStatus(
      "Show companies in event",
      this.props.userPermissions
    );
    const locationPermission = getPermissionStatus(
      "Show locations in event",
      this.props.userPermissions
    );

    if (companiesPermission) {
      if (!this.props.allCompanies) {
        this.props.fetchAllCompanies();
      }
    } else {
      this.props.allowChallengeEventForSpouseDependent();
      this.setState({
        companies: this.props.userCompany ? [this.props.userCompany.id] : [],
      });
    }

    this.setState({ companiesPermission, locationPermission });

    if (this.props.companyDetails?.id) {
      this.props.getCompanyDepartment(this.props.companyDetails.id);
      this.props.getCompanyLocation(this.props.companyDetails.id);
      this.getTeams(this.props.companyDetails.id);
      this.fetchAvailableMonths(this.props.companyDetails.id);
    }

    if (this.props.companyInfo?.id) {
      this.props.getCompanyInitiatives(this.props.companyInfo.id);
    }

    const challengeId = this.props.history.location?.state?.challenge_id;
    if (challengeId) {
      this.fetchChallengeDetails(challengeId);
    }
  }

  fetchChallengeDetails = async (challengeId) => {
    try {
      const res = await fetchApi(`${GetWellnessChallengeDetailsById}/${challengeId}`, "GET");
      if (res.success === "success") {
        const data = res.data;

        // "1_week" → 1, "4_week" → 4
        const challengeLength = data.challenge_length
          ? parseInt(data.challenge_length.split('_')[0], 10)
          : null;


        const imageArray = data.image ? data.image.split('/') : [];
        const imageName = imageArray.length ? imageArray[imageArray.length - 1] : '';

        this.setState({
          challengeDetails: data,
          challengeLength,
          title: data.title || "",
          description: data.description || "",
          imgSrc: data.image ? `${ImageUrl}/${data.image}` : "",
          imageName,
          videoUrl: data.intro_media_type === "mp4" ? data.intro_media_link || "" : "",
          isVideoUrl: data.intro_media_type === "mp4",
        });
      } else {
        toast.error(res.message || "Failed to fetch challenge details");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  componentDidUpdate(prevProps) {
    if (this.state.buttonClickScrollTop) {
      window.scrollTo(0, 0);
      window.setTimeout(() => {
        this.setState({ buttonClickScrollTop: false });
      }, 2000);
    }
    if (!this.state.companiesPermission && this.props.userCompany !== prevProps.userCompany) {
      this.setState({
        companies: this.props.userCompany ? [this.props.userCompany.id] : [],
      });
    }
    if (prevProps.allCompanies !== this.props.allCompanies) {
      this.setState({ filteredCompanies: this.props.allCompanies });
    }
    if (this.props.createEventError && this.state.buttonStatus) {
      this.setState({ buttonStatus: false });
    }
  }

  // ─── Audience targeting methods ──────────────────────────────────────────────

  getTeams = async (companyId) => {
    const AuthToken = localStorage.getItem("AUTH_TOKEN");
    try {
      const res = await http.get(`${GetTeams}/${companyId}`, {
        headers: { AUTHTOKEN: AuthToken },
      });
      if (res.message) {
        toast.error(res.message);
      } else {
        this.setState({ allTeams: res });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  inviteToggleButton = (e) => {
    this.setState({ usersToInvite: e });
  };

  companyToggleButton = (e) => {
    this.setState({
      selectedCompanyCheckBox: e,
      companies: [],
      selectedCompanyValue: "",
    });
    if (e === 0) {
      this.setState({ city_location: [] });
    }
  };

  onSelectLocation = (name) => {
    this.setState({
      companies: [name.id],
      isEmployee: false,
      isDependent: false,
      isSpouse: false,
      selectedCompanyValue: name.company_name,
    });
    this.props.getCompanyLocation(name.id);
    this.props.getCompanyDepartment(name.id);
    this.getTeams(name.id);
  };

  onCheckboxChange = (element, value) => {
    const { companies } = this.state;
    if (companies.includes(element)) {
      const index = companies.findIndex((item) => item === element);
      if (index > -1) companies.splice(index, 1);
    } else {
      companies.push(element);
    }
    this.setState({ companies: companies, selectedCompanyValue: value });
  };

  selectAllCompanies = (e) => {
    e.preventDefault();
    const { allCompanies } = this.props;
    if (this.state.companies.length === allCompanies.length) {
      this.setState({ companies: [] });
    } else {
      this.setState({ companies: allCompanies.map((c) => c.id) });
    }
  };

  onChangeLocation = (id) => {
    const { city_location } = this.state;
    if (city_location.includes(id)) {
      city_location.splice(city_location.findIndex((i) => i === id), 1);
    } else {
      city_location.push(id);
    }
    this.setState({ city_location });
  };

  selectAllLocation = (e, locationDetails) => {
    e.preventDefault();
    if (this.state.city_location.length === locationDetails.length) {
      this.setState({ city_location: [] });
    } else {
      this.setState({ city_location: locationDetails.map((l) => l.id) });
    }
  };

  onChangeDepartment = (id) => {
    const { departments } = this.state;
    if (departments.includes(id)) {
      departments.splice(departments.findIndex((i) => i === id), 1);
    } else {
      departments.push(id);
    }
    this.setState({ departments });
  };

  selectAllDepartment = (e, locationDetails) => {
    e.preventDefault();
    if (this.state.departments.length === locationDetails.length) {
      this.setState({ departments: [] });
    } else {
      this.setState({ departments: locationDetails.map((d) => d.id) });
    }
  };

  onChangeTeam = (id) => {
    const { teams } = this.state;
    if (teams.includes(id)) {
      teams.splice(teams.findIndex((i) => i === id), 1);
    } else {
      teams.push(id);
    }
    this.setState({ teams });
  };

  selectAllTeam = (e, teamDetails) => {
    e.preventDefault();
    if (this.state.teams.length === teamDetails.length) {
      this.setState({ teams: [] });
    } else {
      this.setState({ teams: teamDetails.map((t) => t.id) });
    }
  };

  removeCommaFromFirstPlace = (str) => {
    if (!str) return "";
    if (str.charAt(0) === ",") return str.substring(1);
    return str;
  };

  selectSpouseDependent = (stateName) => {
    this.setState((prev) => ({ [stateName]: !prev[stateName] }));
  };

  handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    this.setState({ searchTerm: e.target.value });
    const filtered = (this.props.allCompanies || []).filter((c) =>
      c.company_name.toLowerCase().includes(searchTerm)
    );
    this.setState({ filteredCompanies: filtered });
  };

  // ─── Launch timing methods ────────────────────────────────────────────────────

  fetchAvailableMonths = async (companyId) => {
    if (!companyId) return;
    try {
      const res = await fetchApi(
        `${GetRecurringInitiativesMonthsNames}?company_id=${companyId}`,
        "GET"
      );
      if (res?.status === "success") {
        this.setState({
          availableMonths: Array.isArray(res.data.months) ? res.data.months : [],
        });
      }
    } catch {
      // non-blocking
    }
  };

  launchToggleButton = (e) => {
    if (e === 0) {
      this.setState({ launch: e, date: dayjs(), endDate: null });
    } else {
      this.setState({ launch: e, date: null, endDate: null });
    }
  };

  onSelectCategory = (name, value) => {
    this.setState({ [name]: value });
  };

  toggleMenu = () => {
    this.setState((prev) => ({ menuIsOpen: !prev.menuIsOpen }));
  };

  DropdownIndicator = () => (
    <div>{NewDropDownIcon(this.props.brandingColor)}</div>
  );

  hideShowCalendarPopup = (value) => {
    this.setState({ datePopup: value, showDatePopupModal: true });
  };

  hideCalendarPopup = () => {
    this.setState({ showDatePopupModal: false, datePopup: "" });
  };

  onChangeDateValue = (date, stateName) => {
    this.setState({ [stateName]: dayjs(date), showDatePopupModal: false });
  };

 
  // ─── Notification methods ─────────────────────────────────────────────────────

  onChangeEmail = (key) => {
    const { emailOption } = this.state;
    emailOption[key] = emailOption[key] === 0 ? 1 : 0;
    this.setState({ emailOption });
  };

  // ─── Save / launch ────────────────────────────────────────────────────────────

  saveAndLaunch = async () => {
    const {
      title,
      description,
      challengeDetails,
      challengeLength,
      isVideoUrl,
      videoUrl,
      date,
      emailOption,
      usersToInvite,
      companies,
      departments,
      city_location,
      teams,
      isSpouse,
      isDependent,
      challengePointValue,
      pillar_Id,
    } = this.state;

    const libraryId = this.props.history.location?.state?.challenge_id;

    this.setState({ buttonStatus: true });

    let challenge_for = "all_company_users";
    if (usersToInvite === 1) challenge_for = "departments";
    else if (usersToInvite === 2) challenge_for = "locations";
    else if (usersToInvite === 3) challenge_for = "teams";

    const payload = {
      challenge_type: "wellness",
      library_id: libraryId,
      pillar_id: pillar_Id,
      title,
      description,
      image: challengeDetails?.image || "",
      intro_media_type: challengeDetails?.intro_media_type || (isVideoUrl ? "mp4" : "mp3"),
      intro_media_link: isVideoUrl ? videoUrl : (challengeDetails?.intro_media_link || ""),
      points: challengePointValue,
      challenge_start_date: dayjs(date).format("YYYY-MM-DD"),
      challenge_length: challengeLength,
      challenge_for,
      challenge_for_spouse: isSpouse,
      challenge_for_dependent: isDependent,
      notification_config: {
        challenge_creation: !!emailOption.launch_event_email,
        challenge_reminder: !!emailOption.event_reminder_email,
        challenge_completion: !!emailOption.event_complete_email,
      },
      company_ids: companies,
      department_ids: departments,
      city_state_ids: city_location,
      team_ids: teams,
    };

    try {
      const res = await fetchApi(LaunchWellnessChallenge, "POST", payload);
      if (res?.success === "success") {
        toast.success("Challenge launched successfully!");
        this.redirect();
      } else {
        toast.error(res?.message || "Failed to launch challenge");
        this.setState({ buttonStatus: false });
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      this.setState({ buttonStatus: false });
    }
  };

  // ─── Existing challenge detail methods ────────────────────────────────────────

  isUrl = (videoUrl) => {
    const UrlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
    if (!videoUrl) {
      this.setState({ isVideoUrl: false, iseventUrlMsg: "" });
      return;
    }
    if (UrlRegex.test(videoUrl)) {
      this.setState({ isVideoUrl: true, iseventUrlMsg: "" });
    } else {
      this.setState({ isVideoUrl: false, iseventUrlMsg: "Please enter valid URL" });
    }
  };

  getAllWellbeingPillars = async () => {
    try {
      const res = await fetchApi(GetWellbeingPillars, "GET");
      if (res.status === "success") {
        this.setState({ wellbeingPillars: res?.data });
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  onSelectPoints = (name) => {
    const numWeeks = name.value;
    const weeksData = Array.from({ length: numWeeks }, () =>
      Array.from({ length: 7 }, () => ({
        goal: "",
        video_link: "",
        media_type: "yes-no",
        media_link: "",
        task: "",
        journalingNotification: "",
        notCompletedNotification: "",
      }))
    );
    this.setState({
      selectedChallengePoint: name.value,
      challengePointKey: name.key,
      challengePointValue: name.value,
      weeksData,
      expandedWeek: 0,
      expandedDay: null,
    });
  };

  onChangeInput = (e) => {
    if (e.target.value.charAt(0) !== " ") {
      this.setState({ [e.target.name]: e.target.value });
    }
    if (e.target.name === "videoUrl") {
      this.isUrl(e.target.value);
    }
  };

  removePhoto = () => {
    this.setState({ imgSrc: "", imageName: "" });
  };

  onImageFileChange = (file, baseImage, imageName) => {
    this.setState({ imgSrc: baseImage, imageName, imageFile: file });
  };

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
      trimmedString.length === 7 ||
      trimmedString === "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });
    const plainText = newContent.replace(/<[^>]*>/g, "").trim();
    this.setState({ charCount: plainText.length });
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true });
  };

  redirect = () => {
    this.props.history.goBack();
  };

  renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect}>
        <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon("#DA6C74")}</ManagerIconContainer>
      </div>
      Launch Challenge
    </FormHeading>
  );

  // ─── Step forms ───────────────────────────────────────────────────────────────

  stepOneForm = () => {
    const { description, step, charCount } = this.state;
    const { t } = this.props;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="launch-legacy-challenge" />
            </div>
            <div className="form">
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>
                    {this.props.t("Title of the challenge")}{<span>*</span>}
                  </StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Enter challenge title")}
                    name="title"
                    onChange={this.onChangeInput}
                    value={this.state.title}
                    maxLength="50"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                    disabled
                  />
                  <div className="count">{this.state.title?.length}/50 | C</div>
                </InputContainer>

                <Border style={{ background: "#EFEFEF", margin: "20px 0 8px 0px", display: "flex" }} />

                <div style={{ display: "flex", gap: "12px" }}>
                  <div>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>
                      {this.props.t("Challenge image")}<span className="subtext">{("(Size limit up to 2 MB)")}</span>{<span>*</span>}
                    </StyledLabel>
                    <CommonImageUploaderFile
                      imgSrc={this.state.imgSrc}
                      t={t}
                      closeIcon={closeIcon}
                      UploadIcon={UploadHDMIcon}
                      onFileChange={this.onImageFileChange}
                      onRemoveImage={this.removePhoto}
                      isMaxSize={true}
                      isText={"(.jpeg, .png) (1920px * 1080px)"}
                      disabled
                    />
                  </div>
                </div>
                <Border style={{ background: "#EFEFEF", margin: "20px 0 8px 0px" }} />

                <InputContainer isColorError={charCount > 3000 ? true : false}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>
                    {this.props.t("About the challenge")}
                  </StyledLabel>
                  <EditorContainer>
                    <Editor disabled content={description} placeholder={"Enter challenge description"} onChange={this.onChangeDescription} />
                  </EditorContainer>
                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  stepTwoForm = () => {
    const { step, challengePointValue, challengePointKey } = this.state;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="launch-legacy-challenge" />
            </div>
            <div className="form">
              <div className="formBody">
                <CommonDropdown
                  tileContainerStyle={{ width: "100%", padding: "0px 0px 8px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={"Challenge point value"}
                  isSubText={"(per day)"}
                  dropdownOpen={this.state.so}
                  placeholder={"Select Point"}
                  title={challengePointKey}
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={wellnessChallengePoints}
                  onSelect={this.onSelectPoints}
                  active={challengePointValue}
                  itemValue={true}
                  onSelectParameter={["value", "key"]}
                  dropIcon={true}
                  valueIndex={1}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                  isRequired={true}
                />
                <Border style={{ background: "#EFEFEF", margin: "20px 0 8px 0px", display: "flex" }} />
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  stepThreeForm = () => {
    const {
      companies,
      city_location,
      companiesPermission,
      step,
      selectedCompanyCheckBox,
      isDependent,
      isSpouse,
      usersToInvite,
      allTeams,
      filteredCompanies,
      departments,
      teams,
    } = this.state;
    const { allCompanies, locationDetails, t, companyDetails, departmentDetails } = this.props;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#184A61"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="launch-legacy-challenge" />
            </div>
            <div className="form">
              <div className="formBody">
                {companiesPermission && (
                  <StyledLabel color="#184A61">
                    {t("Host your event for?")}{<span>*</span>}
                  </StyledLabel>
                )}
                {companiesPermission && (
                  <div className="radioButtonDiv">
                    <span onClick={() => this.companyToggleButton(0)}>
                      <CustomRadioButton
                        id="global"
                        handler={this.companyToggleButton}
                        value={0}
                        isChecked={selectedCompanyCheckBox === 0}
                        label={t("Global")}
                        challengeCreate={true}
                        style={{ color: "#184A61" }}
                        newBranding={true}
                      />
                    </span>
                    <span onClick={() => this.companyToggleButton(1)}>
                      <CustomRadioButton
                        id="company"
                        handler={this.companyToggleButton}
                        value={1}
                        isChecked={selectedCompanyCheckBox === 1}
                        label={t("For an Individual Company")}
                        challengeCreate={true}
                        style={{ color: "#184A61" }}
                        newBranding={true}
                      />
                    </span>
                  </div>
                )}

                {selectedCompanyCheckBox === 0 && companiesPermission && (
                  <Heading>
                    <div className="name" style={{ color: "#184A61" }}>
                      {t("Select companies to invite")} &nbsp;
                      <span>{companies.length > 0 ? "(" + companies.length + " Companies Selected)" : ""}</span>
                    </div>
                    <SearchFilter1 style={{ width: "416px", maxWidth: "416px", background: "background" }}>
                      <StyledInputV2
                        type="text"
                        placeholder={t("Search company")}
                        value={this.state.searchTerm}
                        onChange={this.handleSearch}
                        style={{ border: "none" }}
                      />
                      <SearchIcon>{SearchButtonIcon()}</SearchIcon>
                    </SearchFilter1>
                  </Heading>
                )}

                {selectedCompanyCheckBox === 0 && companiesPermission ? (
                  <Locationwrapper background="white">
                    <div className="checkBoxWidth">
                      <span style={{ color: "#184A61" }}>
                        <StyledCustomRadioButton
                          onClick={(e) => this.selectAllCompanies(e)}
                          style={{ color: "#184A61", border: "1px solid #669db7" }}
                          background={"#85c0ea"}
                          width="20px"
                          height="20px"
                          className="parentRadioBtn"
                        >
                          {allCompanies && companies.length === allCompanies.length && <div></div>}
                        </StyledCustomRadioButton>{" "}
                        {t("All Companies")}
                      </span>
                    </div>
                    {filteredCompanies && filteredCompanies.length > 0
                      ? filteredCompanies.map((company, index) => (
                        <div className="checkBoxWidth" key={index}>
                          <span style={{ color: "#184A61" }}>
                            <StyledCustomRadioButton
                              onClick={() => this.onCheckboxChange(company.id, company.company_name)}
                              background="#afcbd3"
                              style={{ border: "1px solid #649bb3" }}
                              width="20px"
                              height="20px"
                              className="parentRadioBtn"
                            >
                              {companies.includes(company.id) && <span className="selected"></span>}
                            </StyledCustomRadioButton>
                            {company.company_name}
                          </span>
                        </div>
                      ))
                      : null}
                  </Locationwrapper>
                ) : (
                  companiesPermission && (
                    <React.Fragment>
                      <Heading>
                        <div className="name" style={{ color: "#184A61" }}>
                          {t("Select a company to invite")} <span>&nbsp;{companies.length === 1 ? "(01 Company Selected)" : ""}</span>
                        </div>
                        <SearchFilter1 style={{ width: "416px", maxWidth: "416px" }}>
                          <StyledInputV2
                            type="text"
                            placeholder={t("Search company")}
                            value={this.state.searchTerm}
                            onChange={this.handleSearch}
                            style={{ border: "none" }}
                          />
                          <SearchIcon>{SearchButtonIcon()}</SearchIcon>
                        </SearchFilter1>
                      </Heading>
                      <Locationwrapper background="white">
                        {filteredCompanies && filteredCompanies.length > 0
                          ? filteredCompanies.map((company, index) => (
                            <div className="checkBoxWidth" key={index}>
                              <span style={{ color: "#184A61" }} onClick={() => this.onSelectLocation(company)}>
                                <CustomRadioButton
                                  handler={() => this.onSelectLocation(company)}
                                  id={company.id}
                                  value={companies}
                                  isChecked={companies.includes(company.id)}
                                  label={t(company.company_name)}
                                  style={{ color: "#184A61" }}
                                  challengeCreate={true}
                                  newBranding={true}
                                />
                              </span>
                            </div>
                          ))
                          : null}
                      </Locationwrapper>
                    </React.Fragment>
                  )
                )}

                {/* <div className="name" style={{ color: "#184A61", marginBottom: "16px" }}>
                  {t("Who would you like to invite?")}
                </div> */}

                <StyledLabel color="#184A61" marginb={"16px"}  margin={"0px"}>
                  {t("Who would you like to invite?")}{<span>*</span>}
                </StyledLabel>
                <Locationwrapper background="white">
                  <div className="checkBoxWidth" style={{ width: "20.33%", marginBottom: "0px" }}>
                    <span style={{ color: "#092F41" }}>
                      <StyledCustomRadioButton
                        onClick={() => this.inviteToggleButton(0)}
                        background="#afcbd3"
                        width="20px"
                        height="20px"
                        className="parentRadioBtn"
                      >
                        {usersToInvite === 0 && <span className="selected"></span>}
                      </StyledCustomRadioButton>
                      {t("All Users")}
                    </span>
                  </div>

                  {departmentDetails && departmentDetails.length ? (
                    <div className="checkBoxWidth" style={{ width: "20.33%", marginBottom: "0px" }}>
                      <span style={{ color: "#092F41" }}>
                        <StyledCustomRadioButton
                          onClick={() => this.inviteToggleButton(1)}
                          background="#afcbd3"
                          width="20px"
                          height="20px"
                          className="parentRadioBtn"
                        >
                          {usersToInvite === 1 && <span className="selected"></span>}
                        </StyledCustomRadioButton>
                        {t("Departments")}
                      </span>
                    </div>
                  ) : null}

                  {locationDetails && locationDetails.length ? (
                    <div className="checkBoxWidth" style={{ width: "20.33%", marginBottom: "0px" }}>
                      <span style={{ color: "#092F41" }}>
                        <StyledCustomRadioButton
                          onClick={() => this.inviteToggleButton(2)}
                          background="#afcbd3"
                          width="20px"
                          height="20px"
                          className="parentRadioBtn"
                        >
                          {usersToInvite === 2 && <span className="selected"></span>}
                        </StyledCustomRadioButton>
                        {t("Locations")}
                      </span>
                    </div>
                  ) : null}

                  {allTeams && allTeams.length ? (
                    <div className="checkBoxWidth" style={{ width: "20.33%", marginBottom: "0px" }}>
                      <span style={{ color: "#092F41" }}>
                        <StyledCustomRadioButton
                          onClick={() => this.inviteToggleButton(3)}
                          background="#afcbd3"
                          width="20px"
                          height="20px"
                          className="parentRadioBtn"
                        >
                          {usersToInvite === 3 && <span className="selected"></span>}
                        </StyledCustomRadioButton>
                        {t("Teams")}
                      </span>
                    </div>
                  ) : null}
                </Locationwrapper>

                {usersToInvite !== 0 && (
                  <Border style={{ background: "#EFEFEF", margin: "8px 0px 0px 0px", display: "flex" }} />
                )}

                {locationDetails && locationDetails.length > 0 && usersToInvite === 2 && (
                  <>
                    <div className="name" style={{ color: "#184A61", marginTop: "12px" }}>
                      {t("Select Locations")}<span className="global-star">*</span>
                    </div>
                    <Locationwrapper marginBottom={"8px"} background="white" style={{ zIndex: "10", position: "relative" }}>
                      <div className="checkBoxWidth">
                        <span style={{ color: "#092F41" }}>
                          <ManagerIconContainer selected={city_location?.length === locationDetails?.length}>
                            <div className="archive-action" onClick={(e) => this.selectAllLocation(e, locationDetails)}>
                              {city_location?.length === locationDetails?.length ? RecognitionTickIcon() : null}
                            </div>
                          </ManagerIconContainer>
                          {city_location?.length === locationDetails.length ? t("Deselect All") : t("All Locations")}
                        </span>
                      </div>
                      {locationDetails.map((loc, index) => (
                        <div className="checkBoxWidth" key={index}>
                          <span style={{ color: "#092F41" }}>
                            <ManagerIconContainer selected={city_location.includes(loc.id)}>
                              <div className="archive-action" onClick={() => this.onChangeLocation(loc.id)}>
                                {city_location.includes(loc.id) ? RecognitionTickIcon() : null}
                              </div>
                            </ManagerIconContainer>
                            {this.removeCommaFromFirstPlace(loc.location)}
                          </span>
                        </div>
                      ))}
                    </Locationwrapper>
                  </>
                )}

                {departmentDetails && departmentDetails.length > 0 && usersToInvite === 1 && (
                  <>
                    <div className="name" style={{ color: "#184A61", marginTop: "12px" }}>
                      {t("Select Departments")}<span className="global-star">*</span>
                    </div>
                    <Locationwrapper marginBottom={"8px"} background="white" style={{ zIndex: "10", position: "relative" }}>
                      <div className="checkBoxWidth">
                        <span style={{ color: "#092F41" }}>
                          <ManagerIconContainer selected={departments?.length === departmentDetails?.length}>
                            <div className="archive-action" onClick={(e) => this.selectAllDepartment(e, departmentDetails)}>
                              {departments?.length === departmentDetails?.length ? RecognitionTickIcon() : null}
                            </div>
                          </ManagerIconContainer>
                          {departments.length === departmentDetails.length ? t("Deselect All") : t("All Departments")}
                        </span>
                      </div>
                      {departmentDetails.map((dep, index) => (
                        <div className="checkBoxWidth" key={index}>
                          <span style={{ color: "#092F41" }}>
                            <ManagerIconContainer selected={departments.includes(dep.id)}>
                              <div className="archive-action" onClick={() => this.onChangeDepartment(dep.id)}>
                                {departments.includes(dep.id) ? RecognitionTickIcon() : null}
                              </div>
                            </ManagerIconContainer>
                            {this.removeCommaFromFirstPlace(dep.department)}
                          </span>
                        </div>
                      ))}
                    </Locationwrapper>
                  </>
                )}

                {allTeams && allTeams.length > 0 && usersToInvite === 3 && (
                  <>
                    <div className="name" style={{ color: "#184A61", marginTop: "12px" }}>
                      {t("Select Teams")}<span className="global-star">*</span>
                    </div>
                    <Locationwrapper marginBottom={"8px"} background="white" style={{ zIndex: "10", position: "relative" }}>
                      <div className="checkBoxWidth">
                        <span style={{ color: "#092F41" }}>
                          <ManagerIconContainer selected={teams?.length === allTeams?.length}>
                            <div className="archive-action" onClick={(e) => this.selectAllTeam(e, allTeams)}>
                              {teams?.length === allTeams?.length ? RecognitionTickIcon() : null}
                            </div>
                          </ManagerIconContainer>
                          {teams.length === allTeams.length ? t("Deselect All") : t("Select All")}
                        </span>
                      </div>
                      {allTeams.map((team, index) => (
                        <div className="checkBoxWidth" key={index + team.id}>
                          <span style={{ color: "#092F41" }}>
                            <ManagerIconContainer selected={teams.includes(team.id)}>
                              <div className="archive-action" onClick={() => this.onChangeTeam(team.id)}>
                                {teams.includes(team.id) ? RecognitionTickIcon() : null}
                              </div>
                            </ManagerIconContainer>
                            {this.removeCommaFromFirstPlace(team.name)}
                          </span>
                        </div>
                      ))}
                    </Locationwrapper>
                  </>
                )}

                <Border style={{ background: "#EFEFEF", margin: "8px 0px 0px 0px", display: "flex" }} />

                {companyDetails && companyDetails["spouse_or_dependent"] ? (
                  <div>
                    <StyledLabel color="#184A61" style={{ marginTop: "10px" }}>
                      {t("Are you also interested in extending an invitation?")}
                    </StyledLabel>
                    <Locationwrapper marginBottom={"6px"} background="white" style={{ marginTop: "0px" }}>
                      <div className="checkBoxWidth" style={{ width: "16%" }}>
                        <span style={{ color: "#184A61" }}>
                          <ManagerIconContainer selected={isSpouse}>
                            <div className="archive-action" onClick={() => this.selectSpouseDependent("isSpouse")}>
                              {isSpouse ? RecognitionTickIcon() : null}
                            </div>
                          </ManagerIconContainer>
                          {t("Spouse")}
                        </span>
                      </div>
                      <div className="checkBoxWidth" style={{ width: "16%" }}>
                        <span style={{ color: "#092F41" }}>
                          <ManagerIconContainer selected={isDependent}>
                            <div className="archive-action" onClick={() => this.selectSpouseDependent("isDependent")}>
                              {isDependent ? RecognitionTickIcon() : null}
                            </div>
                          </ManagerIconContainer>
                          {t("Dependent")}
                        </span>
                      </div>
                    </Locationwrapper>
                  </div>
                ) : null}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  stepFourForm = () => {
    const {
      step,
      date,
      time_zone,
      launch,
      showDatePopupModal,
      datePopup,
      challengeLength,
    } = this.state;
    const { t } = this.props;

    // const isScheduleForLater = launch === 1;

    const customStyles = {
      control: (base, state) => ({
        ...base,
        boxShadow: state.isFocused ? null : null,
        "&:hover": { borderColor: state.isFocused ? "hsl(0,0%,70%)" : "hsl(0,0%,70%)" },
      }),
    };

    let timeZoneValue;
    timezones["timezones"].map((zone) => {
      if (zone.value === time_zone) timeZoneValue = zone.label;
    });

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#184A61"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="launch-legacy-challenge" />
            </div>
            <div className="form">
              <div className="formBody">

                <StyledLabel color="#184A61" style={{ marginTop: "0px" }}>
                  {t("When would you like to launch this challenge?")}{<span>*</span>}
                </StyledLabel>

                <Locationwrapper marginBottom={"4px"} background="white">
                  <div className="checkBoxWidth" style={{ width: "20.33%" }}>
                    <span style={{ color: "#092F41" }}>
                      <StyledCustomRadioButton
                        onClick={() => this.launchToggleButton(0)}
                        background="#afcbd3"
                        width="20px"
                        height="20px"
                        className="parentRadioBtn"
                      >
                        {launch === 0 && <span className="selected"></span>}
                      </StyledCustomRadioButton>
                      {t("Launch now")}
                    </span>
                  </div>
                  <div className="checkBoxWidth" style={{ width: "20.33%" }}>
                    <span style={{ color: "#092F41" }}>
                      <StyledCustomRadioButton
                        onClick={() => this.launchToggleButton(1)}
                        background="#afcbd3"
                        width="20px"
                        height="20px"
                        className="parentRadioBtn"
                      >
                        {launch === 1 && <span className="selected"></span>}
                      </StyledCustomRadioButton>
                      {t("Schedule for later")}
                    </span>
                  </div>
                </Locationwrapper>

                <Border style={{ background: "#EFEFEF", margin: "8px 0px 0px 0px", display: "flex" }} />

                <TitleContainer fullWidth margin="0 0 12px 0" style={{ padding: "0px" }}>
                  <StyledLabel color="#184A61" style={{ marginTop: "12px" }}>
                    {t("What is your preferred time zone?")}{<span>*</span>}
                  </StyledLabel>
                  <SearchDropDown
                    pcolor={time_zone ? "#184A61" : "#184A61"}
                    pfont={time_zone ? "rubik-medium" : "rubik"}
                    style={{ height: "50px", width: "100%" }}
                  >
                    <Select
                      defaultValue={
                        time_zone
                          ? timeZoneValue + (this.state.defaultTz === time_zone ? " (System default)" : "")
                          : t("Select Timezone")
                      }
                      options={timezones["timezones"]}
                      onChange={(option) => this.onSelectCategory("time_zone", option.value)}
                      classNamePrefix={"menu-item"}
                      styles={customStyles}
                      components={{ DropdownIndicator: this.DropdownIndicator }}
                      onMenuOpen={this.toggleMenu}
                      onMenuClose={this.toggleMenu}
                      placeholder={
                        time_zone
                          ? timeZoneValue + (this.state.defaultTz === time_zone ? " (System default)" : "")
                          : t("Select Timezone")
                      }
                    />
                  </SearchDropDown>
                </TitleContainer>

                <Border style={{ background: "#EFEFEF", margin: "8px 0px 8px 0px", display: "flex" }} />

                <div className="dateCard" style={{ marginTop: "0px", gap: "8px" }}>
                  <DateCalendarWrapper>
                    <div className="date-title">Start Date</div>
                    <DateCard
                      color={launch === 1 && !date}
                      background={launch === 0}
                      disabled={launch === 0}
                      onClick={launch === 1 ? () => this.hideShowCalendarPopup("date") : null}
                    >
                      {launch === 0 ? dayjs().format("MM/DD/YYYY") : date ? dayjs(date).format("MM/DD/YYYY") : "Enter start date"}
                      {CalendarBranding(launch === 0 ? "#BDBDBD" : undefined)}
                    </DateCard>
                  </DateCalendarWrapper>
                  <DateCalendarWrapper>
                    <div className="date-title">Challenge Length</div>
                    <DateCard color background disabled>
                      {challengeLength ? `${challengeLength} ${challengeLength === 1 ? "week" : "weeks"}` : "—"}
                      {CalendarBranding("#BDBDBD")}
                    </DateCard>
                  </DateCalendarWrapper>
                </div>
                <p style={{
                  color: "var(--Font-Color-on-Dark-theme-100, #989898)",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "14px",
                  margin: "8px 0 0 0",
                }}>
                  {"Select only the start date—your challenge end date will be automatically calculated based on the challenge length."}
                </p>

              </div>
            </div>
          </Container>
        </div>
        {showDatePopupModal && (
          <DatePopupCalendar
            showModal={showDatePopupModal}
            onClose={this.hideCalendarPopup}
            date={date}
            stateDateSelected={dayjs(new Date())}
            changeDate={this.onChangeDateValue}
            type={datePopup}
          />
        )}
      </Layout>
    );
  };

  stepFiveForm = () => {
    const { step, recurringEvent, emailOption, recurringType } = this.state;
    const emailOptionKeys = Object.keys(emailOption);
    const { t } = this.props;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#184A61"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="launch-legacy-challenge" />
            </div>
            <div className="form">
              <div className="formBody">
                <StyledLabel margin={"0px"} isMarginBottom={"12px"} color="#184A61">
                  {t("Email notifications: Select email option for this challenge")}
                </StyledLabel>
                <Locationwrapper border background="none" marginTop="0" padding="0">
                  {emailOptionKeys.map((item, index) => (
                    <div className="checkBoxWidth" key={index}>
                      {recurringType === "recurring" && item === "event_reminder_email" ? null : (
                        <span style={{ color: "#184A61" }}>
                          <CustomCheckBoxButton
                            isSelected={emailOption[item] === 1}
                            onClick={() =>
                              !(index === 0 && recurringEvent !== recurringTypes[0]) &&
                              this.onChangeEmail(item)
                            }
                            width="20px"
                            height="20px"
                          >
                            {emailOption[item] === 1 && <div>{RecognitionTickIcon()}</div>}
                          </CustomCheckBoxButton>
                          {t("Challenge")}
                          {item === "launch_event_email"
                            ? t(" Creation")
                            : item === "event_reminder_email"
                              ? t(" Reminder")
                              : t(" Completion")}
                        </span>
                      )}
                    </div>
                  ))}
                </Locationwrapper>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  stepSixForm = () => {
    const {
      step, date, challengePointValue, challengeLength,
      usersToInvite, departments, city_location, teams, allTeams, emailOption,
    } = this.state;
    const { departmentDetails, locationDetails } = this.props;

    const startStr = date ? dayjs(date).format('MMM D, YYYY') : '';
    const computedEndDate = date && challengeLength ? dayjs(date).add(challengeLength * 7, 'day') : null;
    const endStr = computedEndDate ? computedEndDate.format('MMM D, YYYY') : '';

    const totalDays = challengeLength * 7;
    const totalPoints = (challengePointValue || 0) * totalDays;

    let selectionType = 'All Users';
    let selectionItems = [];
    if (usersToInvite === 1) {
      selectionType = 'Departments';
      selectionItems = (departmentDetails || []).filter((d) => departments.includes(d.id)).map((d) => d.department);
    } else if (usersToInvite === 2) {
      selectionType = 'Locations';
      selectionItems = (locationDetails || []).filter((l) => city_location.includes(l.id)).map((l) => l.location);
    } else if (usersToInvite === 3) {
      selectionType = 'Teams';
      selectionItems = allTeams.filter((t) => teams.includes(t.id)).map((t) => t.name);
    }

    const emailLabels = {
      launch_event_email: 'Challenge Creation',
      event_reminder_email: 'Challenge Reminder',
      event_complete_email: 'Challenge Completion',
    };
    const activeNotifications = Object.keys(emailOption)
      .filter((k) => emailOption[k] === 1)
      .map((k) => emailLabels[k]);

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87" isStepHeight={"auto"} isMinHeight={"0"} alignStart>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="launch-legacy-challenge" />
            </div>
            <div className="form">
              <div className="formBody">
                <SummaryRow>
                  <SummaryColumn divider pr="24px">
                    <SummaryHeading>{`Challenge duration - ${challengeLength} ${challengeLength === 1 ? "week" : "weeks"}`}</SummaryHeading>
                    <SummaryValue>{startStr && endStr ? `${startStr} - ${endStr}` : startStr}</SummaryValue>
                  </SummaryColumn>
                  <SummaryColumn pl="24px">
                    <SummaryHeading>Challenge point value</SummaryHeading>
                    <SummaryValue>{`${challengePointValue || 0} points per day * ${totalDays} days - ${totalPoints} points`}</SummaryValue>
                  </SummaryColumn>
                </SummaryRow>

                <SummaryCard>
                  <SummaryHeading>{`Selection type - ${selectionType}`}</SummaryHeading>
                  {selectionItems.length > 0 && (
                    <SummaryBulletList>
                      {selectionItems.map((item, i) => (
                        <SummaryBulletItem key={i}>{item}</SummaryBulletItem>
                      ))}
                    </SummaryBulletList>
                  )}
                </SummaryCard>

                {activeNotifications.length > 0 ? ( <SummaryCard>
                  <SummaryHeading>Notification</SummaryHeading>
                  {activeNotifications.length > 0 && (
                    <SummaryBulletList>
                      {activeNotifications.map((item, i) => (
                        <SummaryBulletItem key={i}>{item}</SummaryBulletItem>
                      ))}
                    </SummaryBulletList>
                  )}
                </SummaryCard>):null}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  isNextDisabled = () => {
    const { weeksData } = this.state;
    return weeksData.some((week) =>
      week.some((day) => {
        const task = typeof day.task === "string" ? day.task : "";
        return task.trim() === "";
      })
    );
  };

  render() {
    const {
      imgSrc,
      charCount,
      step,
      title,
      loading,
      selectedLinkOption,
      selectedJournalingOption,
      challengePointKey,
      buttonStatus,
      companies,
      city_location,
      usersToInvite,
      departments,
      teams,
      recurringType,
      selectedMonths,
      launch,
      date,
    } = this.state;
    const { role } = this.props;

    if (loading) return <Waiting />;

    const isStep2Disabled =
      !challengePointKey ||
      selectedLinkOption === null ||
      selectedLinkOption === undefined ||
      selectedJournalingOption === null ||
      selectedJournalingOption === undefined;

    const disableStep4Next =
      buttonStatus ||
      (launch === 1 && !date) ||
      (recurringType === "recurring" && selectedMonths.length === 0);

    const isStep3NextDisabled =
      (role === "ADMIN" && companies.length === 0) ||
      (role !== "ADMIN" && companies.length === 0) ||
      (usersToInvite === 2 && city_location.length === 0) ||
      (usersToInvite === 1 && departments.length === 0) ||
      (usersToInvite === 3 && teams.length === 0);

    return (
      <React.Fragment>
        {step === 1
          ? this.stepOneForm()
          : step === 2
            ? this.stepTwoForm()
            : step === 3
              ? this.stepThreeForm()
              : step === 4
                ? this.stepFourForm()
                : step === 5
                  ? this.stepFiveForm()
                  : this.stepSixForm()}

        {step === 1 && (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup
                height="48px"
                width="200px"
                margin="auto 0 auto auto"
                disabled={!title || !imgSrc || charCount > 3000}
                onClick={!title || !imgSrc || charCount > 3000 ? null : () => this.updateStep(2)}
              >
                Next
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        )}

        {step === 2 && (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px" onClick={() => this.updateStep(1)} margin="auto auto auto 0px">
                Back
              </CommonButtonBorder>
              <CommonButtonPopup
                height="48px"
                width="200px"
                margin="auto 0 auto auto"
                disabled={isStep2Disabled}
                onClick={isStep2Disabled ? null : () => this.updateStep(3)}
              >
                Next
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}

        {step === 3 && (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px" onClick={() => this.updateStep(2)} margin="auto auto auto 0px">
                Back
              </CommonButtonBorder>
              <CommonButtonPopup
                height="48px"
                width="200px"
                margin="auto 0 auto auto"
                disabled={isStep3NextDisabled}
                onClick={isStep3NextDisabled ? null : () => this.updateStep(4)}
              >
                Next
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}

        {step === 4 && (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px" onClick={() => this.updateStep(3)} margin="auto auto auto 0px">
                Back
              </CommonButtonBorder>
              <CommonButtonPopup
                height="48px"
                width="200px"
                margin="auto 0 auto auto"
                disabled={disableStep4Next}
                onClick={disableStep4Next ? null : () => this.updateStep(5)}
              >
                Next
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}



        {step === 5 && (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px" onClick={() => this.updateStep(4)} margin="auto auto auto 0px">
                Back
              </CommonButtonBorder>
              <CommonButtonPopup
                height="48px"
                width="200px"
                margin="auto 0 auto auto"
                onClick={() => this.updateStep(6)}
              >
                Preview
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}


        {step === 6 && (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px" onClick={() => this.updateStep(5)} margin="auto auto auto 0px">
                Back
              </CommonButtonBorder>
              <CommonButtonPopup
                height="48px"
                width="200px"
                margin="auto 0 auto auto"
                disabled={buttonStatus}
                onClick={buttonStatus ? null : () => this.saveAndLaunch()}
              >
                Launch Challenge
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}
      </React.Fragment>
    );
  }
}

LaunchLegacyChallengeForm.propTypes = {
  history: PropTypes.object.isRequired,
  t: PropTypes.func,
  allCompanies: PropTypes.array,
  locationDetails: PropTypes.array,
  companyDetails: PropTypes.object,
  departmentDetails: PropTypes.array,
  userCompany: PropTypes.object,
  brandingColor: PropTypes.string,
  role: PropTypes.string,
  userPermissions: PropTypes.array,
  companyInfo: PropTypes.object,
  fetchAllCompanies: PropTypes.func,
  fetchCompanyForUser: PropTypes.func,
  getCompanyLocation: PropTypes.func,
  getCompanyDepartment: PropTypes.func,
  getCompanyInitiatives: PropTypes.func,
  allowChallengeEventForSpouseDependent: PropTypes.func,
  createEventError: PropTypes.string,
};

const mapStateToProps = (state) => ({
  allCompanies: state.challenges.allCompanies,
  userCompany: state.profileData.userCompany,
  locationDetails: state.register.locationDetails,
  companyDetails: state.profileData.companyDetails,
  companyInitiatives: state.companyDashboard.companyInitiatives,
  departmentDetails: state.register.departmentDetails,
  createEventError: state.events.createEventError,
  brandingColor: state.wellnessDashboard.brandingColor,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllCompanies: () => dispatch(getAllCompanies()),
  fetchCompanyForUser: () => dispatch(getUserCompanyDetails()),
  allowChallengeEventForSpouseDependent: () => dispatch(allowChallengeEventForSpouseDependent),
  getCompanyLocation: (id) => dispatch(getCompanyLocation(id)),
  getCompanyDepartment: (id) => dispatch(getCompanyDepartment(id)),
  getCompanyInitiatives: (companyId) => dispatch(getCompanyInitiatives(companyId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LaunchLegacyChallengeForm));
